var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 906,
    height: 788,
    viewBox: "0 0 906 788",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.401869 404.295C3.14187 434.645 20.3119 462.125 30.8119 491.035C45.6655 532.087 47.0665 576.802 34.8119 618.705C32.3119 627.315 29.2319 635.955 29.2219 644.775C29.2219 675.185 63.8719 695.365 95.3519 708.775C175.361 742.742 258.81 767.955 344.242 783.975C372.182 789.245 407.072 791.535 424.752 771.685C433.232 762.155 435.292 749.685 441.522 739.025C457.412 711.765 496.072 701.175 530.772 695.105C572.612 687.792 614.844 682.93 657.252 680.545C699.942 678.145 748.422 676.065 776.712 648.025C794.712 630.205 799.932 605.615 800.642 582.395C802.992 506.205 766.582 423.755 813.312 357.765C832.912 330.085 864.892 309.875 884.312 282.125C912.462 241.905 910.032 190.825 890.972 147.965C871.912 105.105 838.142 68.6646 804.872 32.9646C793.872 21.1546 782.132 8.87461 765.592 3.39461C748.392 -2.30539 728.892 0.314605 710.452 3.00461C626.572 15.2546 539.452 28.5946 469.142 70.6546C434.202 91.5446 405.022 118.655 373.852 143.545C306.522 197.375 228.512 247.105 139.602 268.355C67.3719 285.635 -6.09813 332.215 0.401869 404.295Z",
    fill: "#46A380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92 188.25C274.92 188.25 216.92 178.01 274.92 256.53V188.25Z",
    fill: "#FFBEC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.12 585.83C673.12 585.83 664.72 576.29 641.53 582.04C630.18 571.22 616.04 555.54 615.53 544.17C610.81 545.72 606.2 547.47 601.67 549.39C582.03 527.45 556.86 492.63 557.93 459.11C559.7 404.41 522.14 309.83 522.14 309.83C522.14 309.83 525.24 271.26 519.43 239.38C515.49 217.78 507.43 199.26 491.6 197.85C489.155 197.596 486.683 197.865 484.35 198.64C455.1 208.64 473.27 302.01 473.27 302.01L447.96 380.13L299.59 459.13C299.59 459.13 389.48 577.18 433.12 581.52C433.12 581.52 465.27 615.24 488.43 644.84C480.25 655.84 475.88 663.12 475.88 663.12L498.3 695.04C489.09 707.41 476.13 731.61 504.68 742.97C543.95 758.59 630.35 687.42 630.35 687.42C630.35 687.42 705.41 637.92 673.12 585.83Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.97 187.83C272.97 187.83 213.62 177.41 272.97 257.27V187.83Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.44 262.06C259.44 262.06 237.74 262.06 238.22 288.88C238.265 293.377 239.714 297.748 242.364 301.382C245.013 305.016 248.732 307.732 253 309.15C257.616 310.672 262.646 310.313 267 308.15C270.428 306.486 273.419 304.043 275.733 301.016C278.047 297.989 279.619 294.462 280.325 290.717C281.031 286.973 280.85 283.115 279.797 279.453C278.743 275.792 276.847 272.427 274.26 269.63C270.336 265.48 265.102 262.807 259.44 262.06V262.06Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94 316.5C268.03 315.552 265.932 315.043 263.8 315.01C263.8 315.01 242.85 320.22 246.35 345.39C246.35 345.39 248.1 363.62 266.42 361.01C278.98 359.22 280.47 342.75 280.17 332.57C280.101 329.211 279.111 325.936 277.306 323.102C275.502 320.268 272.954 317.984 269.94 316.5Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.82 383.34C269.21 382.433 267.407 381.922 265.56 381.85C263.293 383.284 261.134 384.882 259.1 386.63C255.691 389.484 252.665 392.768 250.1 396.4C242.2 407.84 239.63 424.65 269.1 441.75V419.17C272.759 415.768 275.839 411.793 278.22 407.4C280.416 403.226 280.87 398.352 279.483 393.844C278.097 389.335 274.982 385.559 270.82 383.34V383.34Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.35 655.52C473.35 655.52 527.12 565.91 609.9 538.6L605.63 587.25L537.03 655.53L473.35 655.52Z",
    fill: "#DFE5EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M473.35 655.52C473.35 655.52 527.12 565.91 609.9 538.6L605.63 587.25L537.03 655.53L473.35 655.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.51 679.42C501.51 679.42 463.1 718.68 501.51 734.04C539.92 749.4 624.41 679.42 624.41 679.42C624.41 679.42 697.81 630.77 666.23 579.56C666.23 579.56 630.39 538.59 501.51 679.42Z",
    fill: "#46A380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.44 565.9C618.44 565.9 506.63 695.63 508.34 676.83C508.84 671.37 502.54 660.49 493.34 647.83C470.99 616.92 431.52 575.3 431.52 575.3C388.85 571.03 300.94 454.96 300.94 454.96L446.03 377.29L470.78 300.48C470.78 300.48 453.02 208.66 481.62 198.83C483.9 198.067 486.318 197.801 488.71 198.05C489.759 198.141 490.8 198.318 491.82 198.58C505.21 201.95 512.27 218.92 515.82 238.58C515.82 238.69 515.87 238.81 515.89 238.92C521.57 270.27 518.54 308.19 518.54 308.19C518.54 308.19 555.24 401.19 553.54 454.99C552.4 490.99 581.85 528.51 601.45 549.38C611.17 559.66 618.44 565.9 618.44 565.9Z",
    fill: "#FFBEC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M463.96 496.77C463.96 496.77 465.67 415.69 451.16 395.21C436.65 374.73 319.7 460.08 319.7 460.08C319.7 460.08 440.92 474.58 463.96 496.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M501.51 525.83C501.51 525.83 554.21 494.67 553.51 444.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M473.35 555.66C473.35 555.66 458.84 576.14 431.53 575.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M618.44 565.9C618.44 565.9 506.63 695.63 508.34 676.83C508.84 671.37 502.54 660.49 493.34 647.83C555.27 626.59 588.89 573.6 601.47 549.36C611.17 559.66 618.44 565.9 618.44 565.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.8 589.55C648.799 589.799 648.772 590.047 648.72 590.29C647 598.93 645.72 607.64 644.31 616.35C643.872 619.118 643.203 621.844 642.31 624.5C639.855 631.575 636.191 638.169 631.48 643.99C597.48 687.07 510.9 709.28 510.9 709.28L510.58 708.81L473.35 655.51C571.5 636.74 609.9 538.59 609.9 538.59C610.64 554.98 639.99 580.46 647.45 586.68C647.868 587.033 648.205 587.472 648.436 587.968C648.667 588.463 648.788 589.003 648.79 589.55H648.8Z",
    fill: "#DFE5EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.86 238.55C491.08 235.38 489.07 214.18 491.01 198.84C491.27 198.75 491.55 198.66 491.82 198.59C505.21 201.96 512.27 218.93 515.86 238.55Z",
    fill: "#EFF4F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M648.8 589.55C648.799 589.799 648.772 590.047 648.72 590.29C647 598.93 645.72 607.64 644.31 616.35C643.872 619.118 643.203 621.844 642.31 624.5L640.2 630.34L635.08 638.83L631.48 643.95C597.48 687.03 510.9 709.24 510.9 709.24L510.58 708.77C513.29 707.65 571.64 683.54 594.97 661.87C617.11 641.32 644.37 594.4 648.27 587.59C648.623 588.183 648.806 588.861 648.8 589.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.37 53.4H286.29C284.029 53.396 281.789 53.8376 279.698 54.6993C277.607 55.561 275.707 56.8261 274.105 58.4224C272.503 60.0186 271.231 61.9147 270.362 64.0025C269.493 66.0902 269.044 68.3286 269.04 70.59V451.79C269.044 454.051 269.493 456.29 270.362 458.378C271.231 460.465 272.503 462.361 274.105 463.958C275.707 465.554 277.607 466.819 279.698 467.681C281.789 468.542 284.029 468.984 286.29 468.98H460.37C462.631 468.984 464.871 468.542 466.962 467.681C469.053 466.819 470.953 465.554 472.555 463.958C474.157 462.361 475.429 460.465 476.298 458.378C477.167 456.29 477.616 454.051 477.62 451.79V70.58C477.609 66.0147 475.786 61.6404 472.552 58.4189C469.317 55.1973 464.935 53.392 460.37 53.4V53.4Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.02 56.58H281.63C275.555 56.58 270.63 61.5049 270.63 67.58V456.37C270.63 462.445 275.555 467.37 281.63 467.37H465.02C471.095 467.37 476.02 462.445 476.02 456.37V67.58C476.02 61.5049 471.095 56.58 465.02 56.58Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.9 94.8H285.76V429.16H460.9V94.8Z",
    fill: "#F1F1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63 77.28C353.508 77.28 354.22 76.5681 354.22 75.69C354.22 74.8118 353.508 74.1 352.63 74.1C351.752 74.1 351.04 74.8118 351.04 75.69C351.04 76.5681 351.752 77.28 352.63 77.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.62 74.1H361.59C361.038 74.1 360.59 74.5477 360.59 75.1V76.28C360.59 76.8323 361.038 77.28 361.59 77.28H394.62C395.172 77.28 395.62 76.8323 395.62 76.28V75.1C395.62 74.5477 395.172 74.1 394.62 74.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.53 456.23C378.688 456.23 383.68 451.238 383.68 445.08C383.68 438.922 378.688 433.93 372.53 433.93C366.372 433.93 361.38 438.922 361.38 445.08C361.38 451.238 366.372 456.23 372.53 456.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7 261.22C261.7 261.22 240.47 261.22 240.95 287.59C240.988 292.002 242.4 296.292 244.99 299.865C247.579 303.437 251.218 306.112 255.4 307.52C259.91 309.002 264.823 308.643 269.07 306.52C273.677 304.246 277.433 300.554 279.785 295.986C282.137 291.418 282.961 286.216 282.136 281.145C281.311 276.073 278.881 271.401 275.202 267.814C271.523 264.228 266.79 261.916 261.7 261.22V261.22Z",
    fill: "#FFBEC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.7 274.83C261.7 274.83 242.07 288.49 259.14 300.43C259.13 300.48 257.42 276.58 261.7 274.83Z",
    fill: "#EFF4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.96 313.28C265.96 313.28 245.48 318.4 248.89 343.15C248.89 343.15 250.6 361.07 268.52 358.51C280.81 356.75 282.26 340.51 281.97 330.51C281.91 327.213 280.946 323.996 279.182 321.21C277.419 318.423 274.924 316.175 271.97 314.71C270.099 313.79 268.045 313.301 265.96 313.28V313.28Z",
    fill: "#FFBEC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.1 324.37C265.1 324.37 245.47 332.05 265.1 353.37C265.1 353.39 255.7 332.91 265.1 324.37Z",
    fill: "#EFF4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.08 415.7V437.89C242.28 421.09 244.79 404.55 252.52 393.31C255.036 389.742 258.004 386.515 261.35 383.71C263.339 381.991 265.452 380.421 267.67 379.01C269.48 379.082 271.245 379.586 272.82 380.48C276.887 382.688 279.921 386.409 281.265 390.837C282.608 395.265 282.154 400.044 280 404.14C277.673 408.451 274.66 412.355 271.08 415.7V415.7Z",
    fill: "#FFBEC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.57 404.6C256.57 404.6 254.35 399.26 252.52 393.3C255.036 389.732 258.004 386.505 261.35 383.7C266.98 392.96 256.57 404.6 256.57 404.6Z",
    fill: "#EFF4F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M515.6 308.59C515.6 308.59 493.41 333.34 486.6 335.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.21 210.22H346.21V211.13C344.483 205.855 340.932 201.369 336.194 198.477C331.457 195.585 325.844 194.477 320.363 195.351C314.882 196.226 309.892 199.026 306.29 203.249C302.687 207.471 300.708 212.84 300.708 218.39C300.708 223.94 302.687 229.309 306.29 233.531C309.892 237.754 314.882 240.554 320.363 241.429C325.844 242.303 331.457 241.195 336.194 238.303C340.932 235.411 344.483 230.925 346.21 225.65V226.56H430.21L440.71 218.44L430.21 210.22ZM324.04 237.22C320.318 237.22 316.679 236.116 313.584 234.048C310.489 231.98 308.077 229.041 306.653 225.602C305.228 222.163 304.856 218.379 305.582 214.728C306.308 211.078 308.1 207.724 310.732 205.092C313.364 202.46 316.718 200.668 320.369 199.942C324.019 199.215 327.803 199.588 331.242 201.013C334.681 202.437 337.62 204.849 339.688 207.944C341.756 211.039 342.86 214.678 342.86 218.4C342.859 220.87 342.371 223.316 341.424 225.598C340.478 227.879 339.091 229.952 337.344 231.698C335.596 233.443 333.522 234.828 331.239 235.772C328.957 236.716 326.51 237.201 324.04 237.2V237.22Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8 195.43C320.251 195.43 315.804 196.779 312.022 199.306C308.239 201.833 305.291 205.426 303.551 209.628C301.81 213.831 301.354 218.455 302.242 222.917C303.129 227.379 305.32 231.477 308.536 234.693C311.753 237.91 315.851 240.101 320.313 240.988C324.774 241.875 329.399 241.42 333.602 239.679C337.804 237.938 341.396 234.99 343.924 231.208C346.451 227.426 347.8 222.979 347.8 218.43C347.8 212.33 345.377 206.48 341.063 202.167C336.75 197.853 330.9 195.43 324.8 195.43V195.43ZM324.8 199.87C328.461 199.87 332.039 200.956 335.083 202.989C338.127 205.023 340.5 207.914 341.901 211.297C343.302 214.679 343.668 218.401 342.954 221.991C342.24 225.582 340.477 228.88 337.888 231.469C335.3 234.057 332.002 235.82 328.411 236.534C324.82 237.249 321.099 236.882 317.716 235.481C314.334 234.08 311.443 231.708 309.409 228.664C307.375 225.62 306.29 222.041 306.29 218.38C306.283 215.945 306.757 213.534 307.685 211.283C308.612 209.032 309.975 206.986 311.694 205.263C313.414 203.539 315.457 202.172 317.706 201.24C319.954 200.308 322.365 199.829 324.8 199.83",
    fill: "#00DD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.23 226.42H346.6V210.35H429.23L439.55 218.43L429.23 226.42Z",
    fill: "#00DD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.21 271.04H346.21V271.95C344.483 266.675 340.932 262.189 336.194 259.297C331.457 256.405 325.844 255.297 320.363 256.171C314.882 257.046 309.892 259.846 306.29 264.068C302.687 268.291 300.708 273.66 300.708 279.21C300.708 284.76 302.687 290.129 306.29 294.351C309.892 298.574 314.882 301.374 320.363 302.249C325.844 303.123 331.457 302.015 336.194 299.123C340.932 296.231 344.483 291.745 346.21 286.47V287.38H430.21L440.71 279.26L430.21 271.04ZM324.04 298.04C320.318 298.04 316.679 296.936 313.584 294.868C310.489 292.8 308.077 289.861 306.653 286.422C305.228 282.983 304.856 279.199 305.582 275.548C306.308 271.898 308.1 268.544 310.732 265.912C313.364 263.28 316.718 261.488 320.369 260.762C324.019 260.035 327.803 260.408 331.242 261.833C334.681 263.257 337.62 265.669 339.688 268.764C341.756 271.859 342.86 275.498 342.86 279.22C342.859 281.69 342.371 284.136 341.424 286.418C340.478 288.699 339.091 290.772 337.344 292.518C335.596 294.263 333.522 295.648 331.239 296.592C328.957 297.536 326.51 298.021 324.04 298.02V298.04Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8 256.25C320.251 256.25 315.804 257.599 312.022 260.126C308.239 262.653 305.291 266.246 303.551 270.448C301.81 274.651 301.354 279.275 302.242 283.737C303.129 288.199 305.32 292.297 308.536 295.513C311.753 298.73 315.851 300.921 320.313 301.808C324.774 302.696 329.399 302.24 333.602 300.499C337.804 298.758 341.396 295.81 343.924 292.028C346.451 288.246 347.8 283.799 347.8 279.25C347.8 273.15 345.377 267.3 341.063 262.987C336.75 258.673 330.9 256.25 324.8 256.25ZM324.8 260.69C328.461 260.69 332.039 261.776 335.083 263.809C338.127 265.843 340.5 268.734 341.901 272.117C343.302 275.499 343.668 279.221 342.954 282.811C342.24 286.402 340.477 289.7 337.888 292.289C335.3 294.877 332.002 296.64 328.411 297.354C324.82 298.069 321.099 297.702 317.716 296.301C314.334 294.9 311.443 292.528 309.409 289.484C307.375 286.44 306.29 282.861 306.29 279.2C306.289 276.769 306.766 274.361 307.696 272.115C308.626 269.869 309.989 267.828 311.708 266.109C313.427 264.389 315.468 263.026 317.715 262.096C319.961 261.167 322.369 260.689 324.8 260.69",
    fill: "#FF5288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.23 287.24H346.6V271.17H429.23L439.55 279.25L429.23 287.24Z",
    fill: "#FF5288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2 202.17L346.9 198.83C346.737 198.667 346.544 198.537 346.331 198.449C346.119 198.36 345.89 198.315 345.66 198.315C345.43 198.315 345.201 198.36 344.989 198.449C344.776 198.537 344.583 198.667 344.42 198.83L323.76 219.33L315.02 210.52C314.857 210.357 314.664 210.227 314.451 210.139C314.239 210.05 314.01 210.005 313.78 210.005C313.55 210.005 313.321 210.05 313.109 210.139C312.896 210.227 312.703 210.357 312.54 210.52L309.23 213.83C309.067 213.993 308.937 214.186 308.849 214.399C308.76 214.611 308.715 214.84 308.715 215.07C308.715 215.3 308.76 215.529 308.849 215.741C308.937 215.954 309.067 216.147 309.23 216.31L322.5 229.69C322.663 229.853 322.856 229.983 323.069 230.071C323.281 230.16 323.51 230.205 323.74 230.205C323.97 230.205 324.199 230.16 324.411 230.071C324.624 229.983 324.817 229.853 324.98 229.69L350.2 204.69C350.363 204.527 350.493 204.334 350.581 204.121C350.67 203.909 350.715 203.68 350.715 203.45C350.715 203.22 350.67 202.991 350.581 202.779C350.493 202.566 350.363 202.373 350.2 202.21V202.17Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.22 201.75L346.08 198.59C345.767 198.277 345.343 198.102 344.9 198.102C344.458 198.102 344.033 198.277 343.72 198.59L324.04 218.11L315.7 209.7C315.387 209.387 314.963 209.212 314.52 209.212C314.078 209.212 313.653 209.387 313.34 209.7L310.2 212.83C309.888 213.143 309.712 213.568 309.712 214.01C309.712 214.452 309.888 214.877 310.2 215.19L322.84 227.93C323.153 228.243 323.578 228.418 324.02 228.418C324.463 228.418 324.887 228.243 325.2 227.93L349.2 204.1C349.513 203.787 349.688 203.362 349.688 202.92C349.688 202.478 349.513 202.053 349.2 201.74L349.22 201.75Z",
    fill: "#00DD90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 490.39,
    y1: 745.19,
    x2: 490.39,
    y2: 197.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10984.5,
    y1: 22093.2,
    x2: 10984.5,
    y2: 17208.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17541.2,
    y1: 17848.9,
    x2: 17541.2,
    y2: 15543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 14300.9,
    y1: 19624,
    x2: 14300.9,
    y2: 17484.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14753.8,
    y1: 30206.7,
    x2: 14753.8,
    y2: 26619.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 108862,
    y1: 218291,
    x2: 108862,
    y2: 45588.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 72823,
    y1: 14094.6,
    x2: 72823,
    y2: 11917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 72823,
    y1: 16993.3,
    x2: 72823,
    y2: 14815.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 20343.3,
    y1: 9330.09,
    x2: 20343.3,
    y2: 8314.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 905.39,
    height: 787.66,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/Privacy.eea4c5f8.svg";
export { ForwardRef as ReactComponent };